import { OfferingDetailMonetaryValue, OfferingDetailValueProps } from './OfferingDetailValue';

export const PropertyAmountBreakdownValue = ({ value, typographyProps, ...rest }: OfferingDetailValueProps) => {
  return (
    <OfferingDetailMonetaryValue
      value={value}
      typographyProps={{ variant: 'body1.semibold', ...typographyProps }}
      {...rest}
    />
  );
};
